import type { UploadCommit, UploadValidation } from "../../../lib/services/warehouse";

/**
 * In-memory only, for the lifetime of this page load — not `sessionStorage`/`localStorage`. This
 * app's `eslint.config.mjs` bans both globals outright (FR-005: the session lives in the BFF's
 * httpOnly cookies, and the ban is enforced on the bare identifier, not scoped to token-shaped
 * data), so a browser-persisted cache is not an option here.
 *
 * Warehouse also has no `GET /stock-uploads/{id}` route (verified against
 * `InventoryController.cs`), so there is nothing to refetch from either. A hard refresh on
 * `/inventory/uploads/preview` therefore loses the preview — the same disclosed, one-session-only
 * limitation `Receipts.tsx` already carries for a just-recorded goods receipt (its own header
 * comment explains why), not a silent gap. `Preview.tsx` renders an honest empty state naming this
 * rather than a generic 404 or a stale re-fetch. This is a real divergence from tasks.md T021's "the
 * id in the route so a refresh survives" — flagged here rather than worked around by reintroducing
 * the banned storage.
 *
 * One pending upload, not a map by id: the preview URL is `/inventory/uploads/preview` (an upload is
 * a cached validation result, not a stored record, so its id has no business in the address), and
 * a newer upload replaces the older one, as it would on screen.
 */
let pending: UploadValidation | UploadCommit | null = null;

export function cacheUpload(value: UploadValidation | UploadCommit): void {
  pending = value;
}

export function getCachedUpload(): UploadValidation | UploadCommit | null {
  return pending;
}
